import { useState, useEffect } from 'react';
import { mustIncludeExtraAddressFields } from 'utilities/logicByCountry';
import scroll from 'utilities/scroll';
import { FORM_VALIDATIONS } from '../constants';

const { FIELDS, EXTRA_FIELDS } = FORM_VALIDATIONS;

export const useValidations = ({ userProfileForm, focusActions, focus }) => {
    const [formValidations, setFormValidations] = useState({
        primaries: FIELDS.PRIMARY,
        firstAddress: FIELDS.FIRST_ADDRESS,
        secondAddress: FIELDS.SECOND_ADDRESS,
    });

    useEffect(() => {
        mustIncludeExtraAddressFields() &&
            setFormValidations({
                primaries: EXTRA_FIELDS.PRIMARY,
                firstAddress: EXTRA_FIELDS.FIRST_ADDRESS,
                secondAddress: EXTRA_FIELDS.SECOND_ADDRESS,
            });
    }, []);

    useEffect(() => {
        if (!userProfileForm.$form.valid && focus.get('triggerValidations')) {
            const errosElements = document.getElementsByClassName('valid-error');
            if (errosElements.length > 0) {
                const input = errosElements[0].getElementsByTagName('input')[0];
                if (typeof input !== 'undefined') {
                    scroll.transition(input);
                    setTimeout(() => {
                        input.focus();
                    }, 250);
                } else {
                    focusActions.setFocusForm(errosElements[0].id);
                    const element = errosElements[0];
                    scroll.transition(element);
                }
            }

            focusActions.triggerValidations(false);
        }
    }, [userProfileForm.$form.valid, focus.get('triggerValidations')]);

    return { formValidations };
};
